import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { Button as ReactStrapButton, ButtonProps } from 'reactstrap';

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ onClick, children, ...rest }, ref) => {
    const buttonRef = useRef<any>(null);

    useImperativeHandle(ref, () => buttonRef.current as HTMLButtonElement);

    const handleClick = (e: any) => {
        if (buttonRef.current) {
            buttonRef.current.setAttribute('disabled', 'disabled')

            if (onClick) {
                onClick(e);
            }

            setTimeout(() => {
                if (buttonRef.current) {
                    buttonRef.current.removeAttribute('disabled')
                }
            }, 1000)
        }
    }

    return (
        <ReactStrapButton {...rest} onClick={handleClick} innerRef={buttonRef}>
            {children}
        </ReactStrapButton>
    )
})

export default Button
